import type { Job } from "@smartsuite/automation-engine-api";
import { collectActionOutputs } from "../../shared/status-walk";

/**
 * @returns empty string if we don't want to show overall job error.
 * We want to display job error only if none of the actions has an error.
 */
export const getJobError = (job: Job): string => {
  const isActionFailed =
    job.actions.some((action) => action.status.oneofKind !== "ok") ||
    collectActionOutputs(job.actionGroupsStatus).some(
      (action) => action.status.oneofKind !== "ok",
    );

  if (!isActionFailed && job.status?.error !== undefined) {
    return job.status.error.message;
  }
  return "";
};
